<template>
    <div class="mx-auto w-full max-w-[1168px] pb-40 px-8 pt-6">
        <template v-if="state==='loaded'">
            <ui-header :title="`Defect ${defect.reference}`"
                       :subtitle="'ID #'+this.defect.id">
                <template #actions>
                    <ui-dropdown placement="bottom-end" menu-class="p-3 w-72" v-if="defect.status==='Draft'">
                        <template #default="{ toggle }">
                            <ui-button-new @click="toggle" primary>
                                Actions
                                <i class="flex-shrink-0 ml-2 fa fa-chevron-down"></i>
                            </ui-button-new>
                        </template>

                        <template #menu="{ close }">
                            <ui-dropdown-item @click.prevent="edit();" icon="fas fa-edit">Edit
                            </ui-dropdown-item>
                            <ui-dropdown-divider v-if="defect.status==='Draft'"/>
                            <ui-dropdown-item @click.prevent="openDeleteModal();" v-if="defect.status==='Draft'"
                                              danger icon="fa fa-trash">Delete
                            </ui-dropdown-item>
                        </template>
                    </ui-dropdown>
                </template>
            </ui-header>

            <ui-tabs active="overview" class="mt-6" :tabs="tabs" #default="{ isActive }">
                <!-- Overview. -->
                <div v-if="isActive('overview')">
                    <ui-data-grid>
                        <ui-data-grid-item label="Package" v-if="!packageReference">
                            <template>{{ defect.packageName }}</template>
                        </ui-data-grid-item>
                        <ui-data-grid-item label="Description of Problem" wide>
                            <div
                                class="min-h-[76px] m-0 px-3 py-2 relative rounded-md shadow-sm block w-full border sm:text-sm focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 border-gray-300 bg-gray-50 whitespace-pre"
                                :class="defect.descriptionOfProblem?'text-gray-500':'text-gray-300'"
                                v-html="defect.descriptionOfProblem?highlight(defect.descriptionOfProblem):'No description of works'">
                            </div>
                        </ui-data-grid-item>
                        <ui-data-grid-item label="Required to Make Good" wide>
                            <div
                                class="min-h-[76px] m-0 px-3 py-2 relative rounded-md shadow-sm block w-full border sm:text-sm focus:outline-none focus:ring-light-blue-500 focus:border-light-blue-500 border-gray-300 bg-gray-50 whitespace-pre"
                                :class="defect.requiredToMakeGood?'text-gray-500':'text-gray-300'"
                                v-html="defect.requiredToMakeGood?highlight(defect.requiredToMakeGood):'No required to make good'">
                            </div>
                        </ui-data-grid-item>
                        <ui-data-grid-item wide>
                            <ui-input-file-inline label="Image, Videos and PDFs"
                                                  name="media[]"
                                                  :filesystemId="defect.filesystemId"
                                                  :readonly="true"
                                                  :downloadUrl="downloadUrl"
                                                  :current-files="getDefectFiles"></ui-input-file-inline>
                        </ui-data-grid-item>
                    </ui-data-grid>
                    <send-log :send-log="combineSendLogs" @revoke="revoke" @resend="resend"></send-log>
                    <ui-data-grid-item class="mt-8" label="Quick action" wide>
                        <div class="flex flex-col md:flex-row flex-wrap -m-2">
                            <ui-button-new v-if="defect.status==='Sent'" class="m-2" icon="fas fa-check-circle"
                                           @click="completeDefect">Mark as Completed
                            </ui-button-new>
                            <ui-button-new v-else-if="defect.status==='Complete'" class="m-2" icon="fas fa-dot-circle"
                                           @click="reopenDefect">Re-Open
                            </ui-button-new>
                            <ui-button-new class="m-2" icon="fas fa-route" extra @click="send">
                                {{ defect.status === 'Sent' ? 'Re-send' : 'Send' }}
                            </ui-button-new>
                        </div>
                    </ui-data-grid-item>
                    <ui-data-grid class="mt-6">
                        <ui-data-grid-item label="Created By">{{ defect.createdBy }} on {{ defect.createdOn }}
                        </ui-data-grid-item>
                        <ui-data-grid-item label="Last Updated By" v-if="defect.lastUpdatedBy">{{
                                defect.lastUpdatedBy
                            }} on {{
                                defect.lastUpdatedOn
                            }}
                        </ui-data-grid-item>
                    </ui-data-grid>
                </div>

                <!-- Notes. -->
                <div v-else-if="isActive('notes')" style="height:calc(100vh - 400px);">
                    <notes-v2 :get-url="defect.getNotesUrl()" :post-url="defect.postNotesUrl()"></notes-v2>
                </div>

            </ui-tabs>
        </template>
    </div>
</template>

<script>
import {Defect} from "@models";
import NotesV2 from "../../NotesV2.vue";
import UiDropdownItem from "../../ui/UiDropdownItem.vue";
import UiHeader from "../../ui/UiHeader.vue";
import UiDropdown from "../../ui/UiDropdown.vue";
import UiButtonNew from "../../ui/UiButtonNew.vue";
import UiDropdownDivider from "../../ui/UiDropdownDivider.vue";
import UiDataGridItem from "../../ui/UiDataGridItem.vue";
import UiDataGrid from "../../ui/UiDataGrid.vue";
import SendLog from "../../send-log/SendLog.vue";
import moment from "moment";
import UiInputFileInline from "../../filesystem/inline/UiInputFileInline.vue";

export default {
    components: {
        UiInputFileInline,
        SendLog,
        UiDataGrid,
        UiDataGridItem,
        UiDropdownDivider, UiButtonNew, UiDropdown, UiHeader, UiDropdownItem, NotesV2
    },
    props: {
        item: Object,
        packageReference: null,
        setEditMode: Function,
        removeItem: Function,
        search: '',
    },
    data() {
        return {
            defect: null,
            tabs: [
                {value: 'overview', label: 'Overview'},
                {value: 'notes', label: 'Notes'},
            ],
            state: 'loading',
        }
    },
    computed: {
        combineSendLogs() {
            return this.defect.sendLog.map((a) => {
                return a;
            }).sort((a, b) => moment(b.requested.at).unix() - moment(a.requested.at).unix())
        }
    },
    methods: {
        revoke(i) {
            this.defect.revoke(i.id);
        },
        resend(i) {
            this.defect.resend(i);
        },
        highlight(string) {
            string = '' + string;
            if (!string || !(typeof string === 'string' || string instanceof String)) {
                return '&nbsp;'
            }
            let htmlSafe = string.replace(/[\u00A0-\u9999<>\&;0123456789#]/g, i => '&#' + i.charCodeAt(0) + ';')
            if (this.search.trim() === '') {
                return htmlSafe
            }
            let search = this.search.toLowerCase().replace(/[\u00A0-\u9999<>\&;0123456789#]/g, i => '&#' + i.charCodeAt(0) + ';')
            const query = search.split(/[\s]+/).filter((item) => {
                return item.trim() !== ''
            })
            let reg = new RegExp(query.join('|'), 'gi');
            let res = htmlSafe.replace(reg, "<span class='bg-blue-200'>$&</span>");
            if (res === '<span class=\'bg-blue-200\'></span>') {
                return '&nbsp;'
            }

            return res
        },
        downloadUrl(id) {
            return route('api.v2.hsqe.defect.file.download', {
                'package_reference': this.item.packageReference,
                'id': this.item.id,
                'file_id': id
            })
        },
        send() {
            this.$modals.open('defect-send-modal', {
                title: `Send Defect`,
                button: 'Send Defect',
                defect: this.item,
                handle: async (messageId, modal) => {
                    modal.close()
                }
            })
        },
        isMimeTypeSupported(mimeType) {
            return ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/heic'].includes(mimeType.toLowerCase())
        },
        edit() {
            this.setEditMode(true);
        },
        async getDefectFiles() {
            return this.defect.files
        },
        async completeDefect() {
            await this.item.markComplete()
            Object.assign(this.defect, this.item);
        },
        async reopenDefect() {
            await this.item.reopen()
            Object.assign(this.defect, this.item);
        },
        openDeleteModal() {
            const title = 'Are you sure you want to delete Defect #' + this.item.reference + '?'
            const description = 'Deleting this Defect is irreversible. Are you sure you want to delete it?'
            eventBus.$emit('delete-modal-open', title, description, async () => {
                await this.item.delete()
                this.removeItem(this.item)
            });
        },
        async updateFromListener(data) {
            if (data.operation === 'updateAggregate') {
                if ((data.aggregate.type === 'Defect') && (data.aggregate.id === this.defect.id)) {
                    Object.assign(this.defect, data.aggregate.data)
                    Object.assign(this.item, data.aggregate.data)
                }
            }
        },

    },
    async mounted() {
        this.defect = await Defect.find(this.item.packageReference, this.item.id)
        this.state = 'loaded'
        if (this.defect) {
            User.registerAggregate({'type': 'Defect', 'id': this.defect.id}, this.updateFromListener)
        }

    }
}
</script>
